import {initTouchScroll} from "./tools/initTouchScroll";
import {getMarkersData} from "./tools/getMarkersData";
import {initMap} from "./tools/initMap";
import {initObjectManager} from "./tools/initObjectManager";
// import {initClusterObjectManager} from "./tools/initClusterObjectManager";
import {createMarkers} from "./tools/createMarkers";

export const initYandexMap = ( mapNode, i ) => {
	if ( ( !mapNode.classList.contains(`loaded`) /*&& !mapNode.closest(`section.contacts`)*/ )
		/*|| ( mapNode.closest(`section.contacts`) && window.innerWidth >= 956 && !mapNode.classList.contains(`loaded`) )*/
	)
	{
		const id = mapNode.getAttribute(`id`);
		const center = [mapNode.getAttribute(`data-latitude`), mapNode.getAttribute(`data-longitude`)];
		const zoom = mapNode.getAttribute(`data-zoom`);

		// const ymapsObjectManager = mapNode.closest(`.complex-list`) ? initClusterObjectManager() : initObjectManager();
		const ymapsObjectManager = initObjectManager();
		const markersData = getMarkersData(id);

		if ( markersData.length > 0 )
		{
			const markers = createMarkers(markersData);

			ymapsObjectManager.add( markers );
		}

		const ymapsMap = initMap(mapNode, ymapsObjectManager, id, center, zoom);
		ymapsMap.geoObjects.add(ymapsObjectManager);

		initTouchScroll(ymapsMap);

		// if ( !mapNode.closest(`.infrastructure`) )
		// {
		// 	ymapsObjectManager.events.add(`click`, (evt) => {
		// 		if ( ymapsMap.balloon.isOpen() )
		// 		{
		// 			const openedBalloonId = ymapsMap.balloon.getData().object.id;
		// 			const clickedBalloonId = evt.get(`objectId`);
		//
		// 			if ( openedBalloonId === clickedBalloonId )
		// 			{
		// 				ymapsMap.balloon.close();
		// 			}
		// 		}
		// 	});
		// }

		ymapsMap.container.getParentElement().classList.add( `loaded` );
		//
		// ymapsMap.events.add(`boundschange`, (evt) => {
		// 	ymapsMap.container.fitToViewport();
		// 	console.log(1)
		// });
	}
};
